import {
  ModalBackdrop,
  ModalBox,
  WithDropdown,
  getPositionAndMaxHeightVertically,
} from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { GhostButton } from '@ardoq/button';
import { Editor } from '@tiptap/react';
import { Icon, IconName } from '@ardoq/icons';
import { RefObject } from 'react';
import { LinkForm, LinkFormLabels } from './LinkForm';
import { selectWholeLink } from '../extensions/LinkExtension';
import { getTextFromSelection } from '../extensions/extensionUtils';

interface LinkDropdownProps {
  editor: Editor;
  isDisabled?: boolean;
  labels?: LinkFormLabels;
  tooltipText?: string;
}

const getInitialHrefAndText = (editor: Editor) => {
  if (editor.isActive('link')) {
    const { href } = editor.getAttributes('link');
    return { href, text: getTextFromSelection(editor) };
  }

  return { href: '', text: getTextFromSelection(editor) };
};

export const LinkDropdown = ({
  editor,
  isDisabled,
  labels,
  tooltipText = 'Link',
}: LinkDropdownProps) => {
  const isActive = editor.isActive('link');

  return (
    <WithDropdown>
      {(openModal, closeModal, isOpen, getHostBox, hostRef) => {
        return (
          <>
            <GhostButton
              data-tooltip-text={isDisabled ? undefined : tooltipText}
              ref={hostRef as RefObject<HTMLButtonElement>}
              isActive={isActive}
              onClick={() => {
                if (isOpen) {
                  closeModal();
                } else {
                  const { from: pos } = editor.state.selection;
                  selectWholeLink('link', editor.view, pos);
                  openModal();
                }
              }}
              isDisabled={isDisabled}
            >
              <Icon iconName={IconName.REFERENCE} />
            </GhostButton>
            {isOpen && (
              <>
                <ModalBackdrop
                  closeModal={() => {
                    closeModal();
                  }}
                  isKeepOpen
                  ignoreKeyboardEvents
                />
                <ModalBox
                  dropdownSize={DropdownSize.AUTO}
                  getHostBox={getHostBox}
                  getPositionAndMaxHeight={(refBox, modalBox) =>
                    getPositionAndMaxHeightVertically({
                      refBox: refBox,
                      modalBox: modalBox,
                      isScrollable: true,
                      forceAlignToRight: false,
                      verticalOffset: 4,
                    })
                  }
                >
                  <LinkForm
                    onSubmit={({ href, text }) => {
                      editor.commands.updateLink(href, text);
                      closeModal();
                    }}
                    getInitialState={() => {
                      return getInitialHrefAndText(editor);
                    }}
                    isActive={isActive}
                    labels={labels}
                  />
                </ModalBox>
              </>
            )}
          </>
        );
      }}
    </WithDropdown>
  );
};
